import React from "react";
import { useSelector } from "react-redux";

function MeetingDetails() {
  const meetingData = useSelector((state) => state.auth.meetingData);

  return (
    <div style={{ padding: "20px", backgroundColor: "#CCCCCC" }}>
      <p style={{ fontWeight: "bold" }}>Telehealth Meeting Details</p>
      <p>Meeting Name: {meetingData?.data?.Name ?? ""}</p>
      <p>Start Time: {meetingData?.data?.StartTime ?? ""}</p>
      <p>End Time: {meetingData?.data?.EndTime ?? ""}</p>
      <p>Course: {meetingData?.data?.CourseName ?? ""}</p>
      <p>Patient Name: {meetingData?.data?.PatientName ?? ""}</p>
    </div>
  );
}

export default MeetingDetails;
